import store2 from 'store2';
import { getConfig } from '../config';
import { isDevelop } from '../helpers';

export const StorageNS = getConfig()?.storageNS || 'sd';
const LocalStore = store2.namespace(StorageNS);

const SessionStore = store2.session.namespace(StorageNS);

const StoreMethod = isDevelop() ? LocalStore : SessionStore;
//console.log('🚀 ~ StoreMethod', { isLocalhost, StoreMethod });
const sessionObjects = ['user', 'hospitalization', 'patient', 'messagelist'];

export const LocalStorage = {
  getItem: (itemName: string, parse = true) => {
    let item = LocalStore.get(itemName);
    if (sessionObjects.includes(itemName)) {
      item = StoreMethod.get(itemName);
    }
    if (parse) {
      try {
        item = JSON.parse(item);
      } catch (e) {}
    }
    return item;
  },

  setItem: (itemName: string, item: any) => {
    if (sessionObjects.includes(itemName)) {
      return StoreMethod.set(itemName, item);
    }
    return LocalStore.set(itemName, item);
  },

  deleteItem: (itemName: string) => {
    if (sessionObjects.includes(itemName)) {
      return StoreMethod.remove(itemName);
    }
    return LocalStore.remove(itemName);
  },
  removeItem: (itemName: string) => {
    //debugger;
    if (sessionObjects.includes(itemName)) {
      return StoreMethod.remove(itemName);
    }
    return LocalStore.remove(itemName);
  },

  clear: () => {
    StoreMethod.clear();
    return LocalStore.clear();
  },

  logout: () => {
    StoreMethod.remove('user');
  },

  getAllItems: () => {
    return localStorage
      .getAllKeys()
      .then((keys: any[]) => {
        const fetchKeys = keys.filter((k: string) => {
          return k.startsWith('');
        });
        return localStorage.multiGet(fetchKeys);
      })
      .then((result: any[]) => {
        return result.map((r: string[]) => {
          return JSON.parse(r[1]);
        });
      });
  },
};

export default LocalStorage;
